/**
 * @generated SignedSource<<69c56eb97c5109c57f268e78d86ce96e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamPickerPopover_store$data = {
  readonly currentEmployee: {
    readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
  } | null;
  readonly me: {
    readonly teams: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly user: {
      readonly " $fragmentSpreads": FragmentRefs<"Avatar_user">;
    };
  } | null;
  readonly " $fragmentType": "TeamPickerPopover_store";
};
export type TeamPickerPopover_store$key = {
  readonly " $data"?: TeamPickerPopover_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamPickerPopover_store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "employeeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamPickerPopover_store",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "employeeId"
        }
      ],
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "currentEmployee",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Avatar_employee"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreUser",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "teams",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Avatar_user"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "49421b1a3220d939126ef1adc7d48388";

export default node;
